/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Og_Cfg_Decklists_ModeInputs */



/**
* | output |
* | --- |
* | "Decklists Visibility" |
*
* @param {Og_Cfg_Decklists_ModeInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const og_cfg_decklists_mode = /** @type {((inputs?: Og_Cfg_Decklists_ModeInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Og_Cfg_Decklists_ModeInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Visibilité des decks")
	if (locale === "es") return /** @type {LocalizedString} */ ("Visibilidad de decks")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Visibilidade das Listas de Deck")
	if (locale === "it") return /** @type {LocalizedString} */ ("Visibilità Decklist")
	return /** @type {LocalizedString} */ ("Decklists Visibility")
});